import { ArrowRight } from "lucide-react";

export const ServiceCard = ({ service, index, large = false }) => {
  const { title, description, icon: Icon } = service;

  if (large) {
    return (
      <div
        className="service-card bg-[#121212] border border-[#2A2A2A] p-8 lg:p-12 card-hover group md:col-span-2"
        data-testid={`service-card-${index}`}
      >
        <div className="flex flex-col h-full">
          <div className="service-icon mb-6">
            <Icon size={48} strokeWidth={1.5} />
          </div>
          <h3 className="font-['Oswald'] text-2xl font-semibold text-white mb-4">
            {title}
          </h3>
          <p className="text-[#A1A1AA] leading-relaxed mb-6 flex-grow">
            {description}
          </p>
          <div className="flex items-center gap-2 text-[#7ED4C6] text-sm font-semibold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">
            Learn More
            <ArrowRight size={16} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="service-card bg-[#121212] border border-[#2A2A2A] p-6 lg:p-8 card-hover group"
      data-testid={`service-card-${index}`}
    >
      <div className="service-icon mb-4">
        <Icon size={36} strokeWidth={1.5} />
      </div>
      <h3 className="font-['Oswald'] text-xl font-semibold text-white mb-3">
        {title}
      </h3>
      <p className="text-[#A1A1AA] text-sm leading-relaxed mb-4">
        {description}
      </p>
      <div className="flex items-center gap-2 text-[#7ED4C6] text-xs font-semibold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">
        Learn More
        <ArrowRight size={14} />
      </div>
    </div>
  );
};
